import type { FC } from 'react';
import type { Match } from '../../../types';
import { DefaultContainerCard, TopDecorColor } from './GenericComponentCssMatchCard';

interface DefaultMatchCardProps {
    matchInfo: Match;
    keyMatchInfo: number | string;
}

const DefaultMatchCard: FC<DefaultMatchCardProps> = ({ matchInfo, keyMatchInfo }) => {
    return (
        <DefaultContainerCard>
            <TopDecorColor />
            DefaultMatchCard
        </DefaultContainerCard>
    );
};

export default DefaultMatchCard;
